<template>
  <mt-popup v-model="moduleState.rolePicMaterial" position="bottom" class="page-module">
    <template>
      <malib-region v-bind:malibConf="{data: malib.comentData.secondData, id: thirdId}"
                    @cut="classifyCut($event, 63)"></malib-region>
      <div class="content-wrapper">
        <mt-loadmore
          ref="loadmore"
          :auto-fill=false
          :bottom-method="loadBottom"
          :bottom-all-loaded="allLoaded"
        >
          <ul class="clearfix">
            <template v-if="maData.length>0">
              <li v-for="item in maData" class="malib-list" @click="usePic(item)">
                <div class="ma-wrapper">
                  <img :src="getSrc(item)" onerror="this.src='../../static/image/maLib_default.png'">
                </div>
              </li>
            </template>
            <template v-else>
              <li v-if="!isLoading">没有数据</li>
            </template>
          </ul>
        </mt-loadmore>
      </div>
      <malib-classify v-bind:malibConf="{data: malib.comentData.firstData, id: secondId}"
                      @cut="classifyCut($event, 64)"></malib-classify>
    </template>
    <template v-if="isLoading">
      <div class="loading">
        <mt-spinner type="double-bounce" color="#ff6600"></mt-spinner>
      </div>
    </template>
    <malib-filter v-bind:malibConf="{data: malib.comentData.thirdData, id: listId, lock: false}"
                  @cut="classifyCut($event, 62)"></malib-filter>
  </mt-popup>
</template>

<script>
  import {mapState} from 'vuex';
  import store from '../store/store';
  import {ComponentName, Methods, CdnLibrary} from '../const/common';
  import {MaType, MaLib} from '../store/MaLib';
  import malibRegion from './malib_region';
  import malibClassify from './malib_classify';
  import malibFilter from './malib_filter';

  export default {
    name: 'material',
    components: {
      'malib-region': malibRegion,
      'malib-classify': malibClassify,
      'malib-filter': malibFilter
    },
    computed: {
      ...mapState(['MaLimit', 'moduleState', 'roleHeadFlag'])
    },
    store,
    data() {
      return {
        malib: new MaLib(this),
        bigStyle: this.initBigStyle(),
        cdnLibrary: CdnLibrary,
        commonMethods: Methods,
        categoryType: 1,
        isLoading: false,
        firstId: 0,
        secondId: 0,
        thirdId: 0,
        listId: 0,
        page: 1,
        maCount: 0,
        pdb: 0,
        pdt: 0,
        dataLoading: false,
        maData: [],
        MaID: null,
        MaType: null,
        allLoaded: false
      }
    },
    methods: {
      loadBottom() {
        this.loadMore();
      },
      loadMore() {
        this.dataLoading = true;
        this.page++;
        this.classifyCut({id: this.MaID, type: this.MaType, paging: true});
      },
      classifyCut(_event, hash) {
        let _isLoading = false, id = _event.id, type = _event.type, paging = _event.paging;

        this.MaID = id;
        this.MaType = type;
        this.allLoaded = false;
        if (id !== null && type !== null && !paging) {
          this.maData = [];
          this.page = 1;
        }
        if (this.maData.length <= 0) {
          _isLoading = true;
        }
        this.malib.setIdByTitleType(id, type);
        this.malib.initTypeData(MaType.ROLE_PIC, this.page, function (data) {
          let _data = data.data[0].data;

          this.maCount = data.data[0].count;
          for (let i = 0; i < _data.length; i++) {
            this.maData.push(_data[i])
          }
          this.dataLoading = false;
          if (this.page > 1) {
            this.$nextTick(function () {
              this.$refs.loadmore.onBottomLoaded();
            });
          }
          if (this.page >= Math.ceil(parseInt(this.maCount) / this.MaLimit)) {
            this.allLoaded = true;
          }
        }, this.errorComplete, this, _isLoading);
        Methods.checkChapterHash(hash);
        //Methods.openCategory(this.house, this.categoryType, this);
      },
      initBigStyle() {
        return Middle.ProjectData.header.style;
      },
      getSrc(item) {
        return this.cdnLibrary.CDNRES + item.preview.substr(0, 2) + '/' + item.preview;
      },
      usePic(item) {
        Methods.cutComponent([ComponentName.ROLE_PIC_MATERIAL], false);

        this.malib.getGoodDetail(item.id, function (detail) {
          let _datas = detail.data.data.rs_data, _coverName = [], _coverNameRs = [];
          var pathList = [];

          for (let i in _datas) {
            if (_datas[i].file_name.indexOf(this.roleHeadFlag) > -1) {
              pathList.unshift([Middle.FileType.PictureFace]);

            } else {
              pathList.push([Middle.FileType.PictureNormal, "half/"]);
            }
          }

          function compare(property) {
            return function (a, b) {
              return a[property] > b[property];
            }
          }

          _datas = _datas.sort(compare('file_name'));
          Middle.ResMap.addList(_datas, pathList);

          _datas.forEach(function (item) {
            _coverName.push(item.file_name);
            _coverNameRs.push(item.rs_url);
          });
          store.state.createRole.coverName = _coverName;
          store.state.createRole.coverNameRs = _coverNameRs;
        }, function (data) {
          console.error(data);
          return alert('图片资源获取失败，请刷新重试');
        }, this);
        Methods.checkChapterHash(65);
      },
      errorComplete() {
      }
    },
    mounted() {
      // debugger;
      this.$nextTick(function () {
        this.classifyCut({id: this.MaID, type: this.MaType, paging: false}, 89);
      })
    }
  }
</script>

<style scoped>
  @import "../style/css/material.css";
</style>



// WEBPACK FOOTER //
// src/components/material.vue